import { render } from "./CohortsPage.vue?vue&type=template&id=5f9416d8"
const script = {}

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__